import React from 'react';
import PropTypes from 'prop-types';
import {
    Button, CircularProgress, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle
} from "@mui/material";

// Diálogo único de confirmación de la app. Reemplaza a window.confirm, a los Swal
// de confirmación y a los Dialog armados a mano: antes cada pantalla elegía sus
// propios textos de botón ("Sí"/"No", "Cancelar"/"Eliminar", el confirm nativo del
// navegador).
//
// Los botones son "Cerrar" y el verbo de la acción, sin el "Sí," adelante, y el de
// confirmar va en el morado de la app: el rojo se reserva para la papelera al pasar
// el mouse, así el diálogo no compite con ella.
//
// El mensaje acepta nodos para poder resaltar el nombre de lo que se borra y
// explicar la consecuencia en una segunda línea, que es lo que ya hacían los
// modales de horarios y de cancelar pedido.
const ConfirmDialog = (
    {
        open,
        title,
        message,
        confirmText = 'Eliminar',
        // El morado sigue siendo el default. `success` es para los diálogos que confirman una
        // accion que suma (agregar pedidos a un viaje), donde el verde ya es el color del boton
        // que abrio el dialogo y cambiarlo aca lo desalinearia del formulario.
        confirmColor = 'primary',
        cancelText = 'Cerrar',
        loading = false,
        onConfirm,
        onClose,
    }) => {
    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            aria-labelledby="confirm-dialog-title"
        >
            <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent>
                {/* component="div" porque los mensajes traen <strong> y <br/>, y un
                    <p> anidando bloques es HTML inválido. */}
                <DialogContentText component="div">{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>{cancelText}</Button>
                <Button
                    variant="contained"
                    color={confirmColor}
                    onClick={onConfirm}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.node,
    message: PropTypes.node,
    // El verbo de la acción ("Eliminar", "Desconectar", "Traer el pedido").
    confirmText: PropTypes.node,
    confirmColor: PropTypes.string,
    cancelText: PropTypes.node,
    loading: PropTypes.bool,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
};

export default ConfirmDialog;
